exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-0a9625d8] tbody td{\n    cursor: pointer;\n}\n[data-v-0a9625d8] tbody td td.non-clickable{\n    cursor: auto;\n}\n.test[data-v-0a9625d8]{\n    background-color: rgba(0, 0, 0, 0);\n}\n", ""]);

// exports
